const tintColor = '#2f95dc';

export default {
  tintColor,
  tabIconDefault: '#ccc',
  tabIconSelected: tintColor,
  tabBar: '#fefefe',
  errorBackground: 'red',
  errorText: '#fff',
  warningBackground: '#EAEB5E',
  warningText: '#666804',
  noticeBackground: tintColor,
  noticeText: '#fff',
  MODAL_COLOR: '#F8F8F8',
  MAIN_BACKGROUND: '#FFDC73',
  ONTRACCR_SUCCESS: '#16A34A',
  ONTRACCR_ERROR: '#EF4444',
  ONTRACCR_RED: '#BF381D',
  ONTRACCR_BLACK: '#323232',
  ONTRACCR_TITLE_BLACK: '#33332D',
  ONTRACCR_OPACITY_GRAY: 'rgba(92, 92, 86, 0.65)',
  ONTRACCR_GRAY: '#5c5c56',
  LIGHT_GRAY: '#C6C6C6',
  OPACITY_LIGHT_GRAY: 'rgba(198, 198, 198, 0.15)',
  DARK_GRAY: '#85857F',
  FADED_ONTRACCR_RED: '#D4897A',
  ONTRACCR_DARK_YELLOW: '#F2BD1E',
  ONTRACCR_MODAL_BACKGROUND_YELLOW: '#F2BD1EC0',
  MODAL_MASK_DARK: '#00000073',
  BREADCRUMB_BACKGROUND: 'rgba(182, 200, 217, 0.1)',
  DIVIDER_COLOR: '#f0f0f0',
  TIME_CARD_STATS_YELLOW: '#F3C33D',
  opacity(color, opacity) {
    const ourOpacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + ourOpacity.toString(16).toUpperCase();
  },
  hexToRGB(hex) {
    if (!hex) return null;

    let parsedHex = hex;

    // We want to ignore the opacity
    if (hex.length > 7) {
      parsedHex = hex.substring(0, 7);
    }

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(parsedHex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    } : null;
  },
  REDESIGN_PRIMARY: '#0070FF',
  REDESIGN_PRIMARY_HOVER: '#003F8F',
  REDESIGN_PRIMARY_TEXT: '#202F3D',
  REDESIGN_SECONDARY_TEXT: '#4A6B8D',
  REDESIGN_DISABLED: '#7396B6',
  REDESIGN_SWITCH_OFF: '#C3D2E0',
  REDESIGN_TAG_BACKGROUND: '#EBF2F7',
  REDESIGN_BUTTON_UNSELECTED_TEXT: '#3C5873',
  REDESIGN_AVATAR_FONT_COLOR: '2E4355',
  REDESIGN_FILE_UPLOAD_ICON: '#D0D5DD',
  BLUE_50: '#D6E9FF',
  BLUE_100: '#B8D7FF',
  BLUE_200: '#A3CCFF',
  BLUE_300: '#7AB5FF',
  BLUE_400: '#529EFF',
  BLUE_500: '#2987FF',
  BLUE_600: '#0070FF',
  BLUE_700: '#0057C7',
  BLUE_800: '#003F8F',
  BLUE_900: '#002657',
  GRAY_50: '#F8FAFC',
  GRAY_100: '#EBF2F7',
  GRAY_200: '#E5E7EB',
  GRAY_300: '#D1D5DB',
  GRAY_400: '#A9BED2',
  GRAY_600: '#7396B6',
  GRAY_700: '#4A6B8D',
  GRAY_800: '#3C5873',
  GRAY_950: '#202F3D',
  GREEN_50: '#F0FDF4',
  GREEN_100: '#DCFCE7',
  GREEN_600: '#16A34A',
  GREEN_700: '#15803D',
  RED_600: '#DC2626',
  ORANGE_100: '#FFEBD4',
  ORANGE_400: '#FD883A',
  ORANGE_500: '#FC6A18',
  DIVISION_BLUE: '#B8D7FF',
  DIVISION_ORANGE: '#FEDFCD',
  DIVISION_GREEN: '#DCFCE7',
  DIVISION_YELLOW: '#FFF5CF',
  DIVISION_PURPLE: '#EDE9FE',
  DIVISION_BADGE: '#B6C8D9',
  YELLOW_500: '#ECAB06',
};
